// extracted by mini-css-extract-plugin
export default {"title":"PopupChainContent_title__6FBQC","select":"PopupChainContent_select__ouRWM"};